// Generated by CoffeeScript 2.7.0
var DatePicker;

import DatePickerContent from './date_picker_content.js';

import DatePickerMixin from './date_picker_mixin.js';

export default DatePicker = Vue.extend({
  mixins: [DatePickerMixin],
  props: {
    initValue: {
      type: Date,
      default: function() {
        return new Date();
      }
    }
  },
  components: {
    'date-picker-content': DatePickerContent
  },
  template: `<date-picker-content :viewMode='viewMode'
                     :displayRange='displayRange'
                     :initValue='initValue'
                     @updateYear='updateYear'
                     @updateMonth='updateMonth'
                     @updateDay='updateDay'>
  <template slot="picker-switch-content">
    <div class="switch-ctrl justify-box">
      <div class="decrease-ctrl" @click='increaseView(-1)'>
        <i class="slp-chevron-left"></i>
      </div>
      <div class="content" @click='reflowView'>{{ displayValue }}</div>
      <div class="increase-ctrl" @click='increaseView(1)'>
        <i class="slp-chevron-right"></i>
      </div>
    </div>
  </template>
</date-picker-content>`
});
